export default "__VITE_ASSET__DRxKmLaj__"